export const initHeroButton = () => {
  const heroBtn = document.querySelector(
    '.secondary-hero.landing .et_pb_row:first-child .et_pb_button.btn-primary',
  );

  if (heroBtn) {
    heroBtn.style.marginTop = '2em';
  }
};
